import { OperationResult, UseMutationState, UseQueryState } from 'urql';

import { CustomError } from '@bodilenergy/util';

export const getFirstError = (result: UseMutationState | UseQueryState | OperationResult): CustomError => {
  return result?.error?.graphQLErrors[0]?.extensions?.exception as CustomError;
};
